import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';

import { Base } from './Base';

const selectors = {
  contentSection: '.product-detail__content-section',
  image: '.product-detail__image'
};

export class VerticalSpacers extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.bindProductImagesUpdatedListener();
  }

  bindProductImagesUpdatedListener() {
    this.productImagesUpdatedHandler = this.handleProductImagesUpdated.bind(this);
    window.addEventListener(events.PRODUCT_IMAGES_UPDATED, this.productImagesUpdatedHandler);
  }

  handleProductImagesUpdated() {
    const contentSectionCount = Array.from(document.querySelectorAll(selectors.contentSection)).length;
    const imageCount = Array.from(document.querySelectorAll(selectors.image)).length;

    let imageSectionCount = imageCount;

    // Need an extra spacer if 3 or more so the last image has time to scroll
    if (imageSectionCount > 2) {
      imageSectionCount++;
    }

    this.sectionCount = contentSectionCount;

    if (imageSectionCount > this.sectionCount) {
      this.sectionCount = imageSectionCount;
    }

    this.buildSections();

    dispatchEvent(window, events.VERTICAL_SPACERS_UPDATED, this.sectionCount);
  }

  buildSections() {
    let html = '';

    for (let i = 0; i < this.sectionCount; i++) {
      html += '<div class="product-detail__vertical-spacer"></div>';
    }

    this.element.innerHTML = html;
  }

  cleanup() {
    window.removeEventListener(events.PRODUCT_IMAGES_UPDATED, this.productImagesUpdatedHandler);
  }
}